<button
  *ngIf="selectedCompanyId"
  (click)="navigateToCampaignBuilder()"
  class="m-2">
  Back to Campaign builder
</button>
<div class="container privacy-policy-page-container">
  <span [innerHTML]="getSafeHtml(privacyPolicy.html)"></span>
</div>
